import { render } from "./FilterMarcaD.vue?vue&type=template&id=a3d0df84"
import script from "./FilterMarcaD.vue?vue&type=script&lang=js"
export * from "./FilterMarcaD.vue?vue&type=script&lang=js"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__